import React, {useState} from 'react';
import {  Button} from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { Alert } from 'react-bootstrap';

function TournoisSuppInscription(props) {
  const [error, setError] = useState(false);
  const [confirmation,setConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;



  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setConfirmation(false);
    try {
        await axios.delete(`${apiUrl}/tournois/participation/supprimer`, {
            withCredentials: true, 
            data: {
                idEquipe: props.userData.user.donnée.results[0].id_equipe,
                idTournois: props.item.id_tournoi
            }});
      setError(null);
      setIsLoading(false);
      window.location.reload(); 

    } catch (error) {
      if (error.response) {
        setIsLoading(false)
        setError(error.response.data.message);
      } else {
        setIsLoading(false)
        setError(true);
      }
    }
  };




  return (
    <>
        {isLoading && 
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
        </div>
    }
    {props.item && (
                        <>
                            <div className="nom" style={{fontSize:"15px",fontWeight:'initial'}}>
                                <strong>Annuler votre participation au tournoi {props.item.nomTournois}</strong>
                            </div> 
                            {error && <Alert variant="danger">{error}</Alert>}
                            <br/>
                            <div style={{textAlign:"center"}}>
                                <Button onClick={()=> setConfirmation(true)} variant="primary" style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >Annuler votre participation</Button>
                            </div>   
                        {confirmation && (
                          <>
                            <Modal show={confirmation} onHide={() => {setConfirmation(false)}}>
                                    <Modal.Header closeButton>
                                      <Modal.Title>Annuler la participation au tournoi {props.item.nomTournois} </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        Voulez-vous vraiment annuler votre participation ?
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary"  onClick={() => {setConfirmation(false)}} >
                                        Quitter
                                      </Button>
                                      <Button variant="primary" onClick={(e) => handleSubmit(e)} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
                                        Confirmer
                                      </Button>
                                    </Modal.Footer>
                            </Modal>
                          </>
                        )}
                    </>
            )}

    </>
  );
}

export default TournoisSuppInscription;